// Toast notification system
let toastContainer;

// Create toast container if it doesn't exist
function ensureToastContainer() {
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.className = 'toast-container';
    document.body.appendChild(toastContainer);
  }
  return toastContainer;
}

// Show a notification
export function showNotification(message, type = 'info', duration = 5000) {
  const container = ensureToastContainer();
  
  // Create toast element
  const toast = document.createElement('div');
  toast.className = `toast toast-${type}`;
  
  // Set icon based on type
  let icon = 'info-circle';
  if (type === 'success') icon = 'check-circle';
  if (type === 'error') icon = 'exclamation-circle';
  
  // Set content
  toast.innerHTML = `
    <div class="toast-icon">
      <i class="fas fa-${icon}"></i>
    </div>
    <div class="toast-message">${message}</div>
    <div class="toast-close">
      <i class="fas fa-times"></i>
    </div>
  `;
  
  // Add to container
  container.appendChild(toast);
  
  // Add close handler
  const closeBtn = toast.querySelector('.toast-close');
  closeBtn.addEventListener('click', () => {
    removeToast(toast);
  });
  
  // Auto remove after duration
  if (duration > 0) {
    setTimeout(() => {
      removeToast(toast);
    }, duration);
  }
  
  return toast;
}

// Remove a toast with animation
function removeToast(toast) {
  toast.style.animation = 'slideOut 0.3s forwards';
  
  toast.addEventListener('animationend', () => {
    toast.remove();
  });
} 